module.exports = __webpack_public_path__ + "img/card_sv4.5ee25c4.png";